import { render, staticRenderFns } from "./ModuleInstance.vue?vue&type=template&id=fac175fe&scoped=true&"
import script from "./ModuleInstance.vue?vue&type=script&lang=js&"
export * from "./ModuleInstance.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInstance.vue?vue&type=style&index=0&id=fac175fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac175fe",
  null
  
)

export default component.exports